import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import RoleBasedGuard from 'src/auth/guard/role-based-guard';

import { RouteGuard } from 'src/components/permissions';
import { LoadingScreen } from 'src/components/loading-screen';

const EmployeesView = lazy(() => import('src/pages/medicore/human-resources/employees-grid-view'));
const DoctorsView = lazy(() => import('src/pages/medicore/human-resources/doctors-grid-view'));
const StaffLeaveView = lazy(
  () => import('src/pages/medicore/human-resources/staff-leave-list-page')
);

const DepartmentsView = lazy(
  () => import('src/pages/medicore/human-resources/departments-list-view')
);
const JobPositionsView = lazy(
  () => import('src/pages/medicore/human-resources/job-positions-list-view')
);
const NewEmployeeRequestListView = lazy(
  () => import('src/pages/medicore/human-resources/new-employee-request-view')
);

const DoctorPlantaAdministration = lazy(()=> import("src/pages/medicore/human-resources/doctor-planta-administration"))

const NewJobPositionsView = lazy(
  () => import('src/pages/medicore/human-resources/new-job-position-grid-view')
);

const EditJobPositionsView = lazy(
  () => import('src/pages/medicore/human-resources/edit-job-position-view')
);

const DetailsJobPositionsView = lazy(
  () => import('src/pages/medicore/human-resources/details-job-position-view')
);

const FingerprintShiftView = lazy(() => import('src/pages/medicore/doctor/fingerprint-shift'));
// ----------------------------------------------------------------------

/**
 * Componente wrapper para proteger rutas de RRHH con permisos específicos
 * ⚠️ ULTRA-RESTRICTIVO: Solo master ve todo, otros usuarios solo lo que tienen permisos
 */
const ProtectedRoute = ({ route, children }) => (
  <RouteGuard route={route} fallbackRoute="/medicore" showFallback>
    <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
  </RouteGuard>
);

ProtectedRoute.propTypes = {
  route: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

// ----------------------------------------------------------------------

export const medicoreHumanResourcesRoutes = [
  {
    path: 'medicore',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['doctor', 'employee']}>
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      {
        path: 'humanResources/employees',
        children: [
          {
            path: 'list',
            element: (
              <ProtectedRoute route="/medicore/humanResources/employees/list">
                <EmployeesView />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'humanResources/doctors',
        children: [
          {
            path: 'list',
            element: (
              <ProtectedRoute route="/medicore/humanResources/doctors/list">
                <DoctorsView />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'humanResources/doctors/shift',
        element: (
          <ProtectedRoute route="/medicore/humanResources/doctors/shift">
            <FingerprintShiftView />
          </ProtectedRoute>
        ),
      },
      {
        path: 'humanResources/departments',
        element: (
          <ProtectedRoute route="/medicore/humanResources/departments">
            <DepartmentsView />
          </ProtectedRoute>
        ),
      },
      {
        path: 'humanResources/leaves',
        element: (
          <ProtectedRoute route="/medicore/humanResources/leaves">
            <StaffLeaveView />
          </ProtectedRoute>
        ),
      },
      {
        path: 'jobPositions',
        children: [
          {
            element: (
              <ProtectedRoute route="/medicore/jobPositions">
                <JobPositionsView />
              </ProtectedRoute>
            ),
            index: true,
          },
          {
            path: 'new',
            element: (
              <ProtectedRoute route="/medicore/jobPositions/new">
                <NewJobPositionsView />
              </ProtectedRoute>
            ),
          },
          {
            path: 'edit/:id',
            element: (
              <ProtectedRoute route="/medicore/jobPositions">
                <EditJobPositionsView />
              </ProtectedRoute>
            ),
          },
          {
            path: 'details/:id',
            element: (
              <ProtectedRoute route="/medicore/jobPositions">
                <DetailsJobPositionsView />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'employeeRequest/request',
        element: (
          <ProtectedRoute route="/medicore/employeeRequest/request">
            <NewEmployeeRequestListView />
          </ProtectedRoute>
        ),
      },
      {
        path: 'DoctorPlanta',
        element: (
          <ProtectedRoute route='/medicore/DoctorPlanta'>
            <DoctorPlantaAdministration/>
          </ProtectedRoute>
        )
      },
    ],
  },
];
